"use client";

import type { HexagonTileStyleInput } from "../lib/hexagon-tile-styles";

export function HexagonGridTile({
	isTranslucent = true,
}: HexagonTileStyleInput) {
	return (
		<div
			className="sq-hex-grid-tile relative size-full"
			data-translucent={isTranslucent ? "true" : "false"}
		>
			<div
				className="sq-hex-grid-tile-shell absolute inset-0 origin-center [clip-path:var(--hex-tile-inner-clip)]"
				aria-hidden
			/>
			<div
				className="sq-hex-grid-tile-face absolute inset-0 origin-center scale-[var(--hexagon-inner-scale)] [clip-path:var(--hex-tile-inner-clip)]"
				aria-hidden
			/>
		</div>
	);
}
